export const siteInfo = {
  name: '就要草视频',
  tagline: '精选视频内容平台',
  description: '就要草视频是您发现和观看优质视频内容的首选平台，汇聚海量精彩视频资源，涵盖电影、电视剧、综艺、动漫、纪录片、音乐、游戏、科技等多种分类，为用户提供流畅、便捷的在线视频观看体验。',
  url: 'https://jiuyaocao.com',
  foundingYear: '2020',
  email: 'contact@jiuyaocao.com',
  phone: '400-888-6666',
  address: '北京市朝阳区望京科技园A座18层',
  socialLinks: {
    weibo: 'https://weibo.com/jiuyaocao',
    wechat: 'jiuyaocao_video',
    bilibili: 'https://space.bilibili.com/jiuyaocao',
    douyin: 'https://www.douyin.com/user/jiuyaocao',
  },
  milestones: [
    { year: '2020', event: '就要草视频平台正式上线，首批收录10万+视频资源' },
    { year: '2021', event: '月活用户突破500万，获得A轮融资' },
    { year: '2022', event: '推出个性化推荐算法，用户留存率提升40%' },
    { year: '2023', event: '移动端App上线，全平台日活用户突破300万' },
    { year: '2024', event: '视频资源库突破百万，覆盖8大分类、50+子分类' },
    { year: '2025', event: '荣获"年度最佳在线视频平台"称号，用户满意度达98%' },
    { year: '2026', event: 'AI智能推荐系统全面升级，4K高清内容占比超过60%' },
  ],
  stats: {
    totalVideos: '1,200,000+',
    dailyActiveUsers: '3,800,000+',
    categories: '8',
    avgRating: '9.1',
    contentCreators: '50,000+',
    monthlyViews: '2.5亿+',
  },
  teamMembers: [
    { name: '张伟', role: '创始人兼CEO', description: '前阿里文娱高级总监，10年+视频行业经验' },
    { name: '李娜', role: '首席技术官', description: '前字节跳动算法专家，AI推荐系统领域权威' },
    { name: '王强', role: '首席内容官', description: '资深媒体人，曾任央视纪录片频道制片人' },
  ],
  faq: [
    { question: '就要草视频是免费的吗？', answer: '就要草视频提供大量免费视频内容供用户观看。部分独家内容和超高清资源可能需要会员订阅，我们会持续增加免费内容的数量和质量，让更多用户享受优质视频体验。' },
    { question: '如何注册就要草视频账号？', answer: '您可以通过手机号、邮箱或微信账号快速注册就要草视频。注册过程简单快捷，只需几步即可完成。注册后您可以收藏视频、订阅频道、参与评论互动。' },
    { question: '就要草视频支持哪些设备观看？', answer: '就要草视频全面支持Web端、iOS App、Android App、智能电视TV版、平板电脑等多种设备，让您随时随地畅享精彩视频内容。一个账号，多端同步观看记录。' },
    { question: '视频加载慢或卡顿怎么办？', answer: '如果遇到播放卡顿，建议您：1) 检查网络连接是否稳定；2) 尝试切换至较低清晰度；3) 清除浏览器缓存后重试；4) 如问题持续，请联系客服获取帮助。我们配备了全球CDN加速节点，确保流畅播放体验。' },
    { question: '如何在就要草视频上传自己的视频？', answer: '注册账号后，您可以在个人中心点击"上传视频"按钮，按照指引完成视频上传。我们支持多种视频格式，上传后我们的审核团队会在24小时内完成内容审核，审核通过后您的视频将公开发布。' },
  ],
};